module.exports = __webpack_public_path__ + "static/media/virtual-travel-card.0a59975e.svg";